import styled from 'styled-components';
import { Alert, Tabs } from '@mui/material';

import colors from '../../../../../styles/colors';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 60%;
  height: 100%;
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  margin-bottom: 8px;
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  color: ${colors.shades.dark2};
`;

export const SubTitle = styled.p`
  font-size: 14px;
  color: ${colors.shades.gamma14};
  margin: 4px 0 0 0;
`;

export const StyledTabs = styled(Tabs)`
  margin-bottom: 16px;
`;

export const EmptyStateAlert = styled(Alert)`
  margin-bottom: 16px;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
`;

export const FormListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const FormRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border: 1px solid ${colors.shades.secondary6};
  border-radius: 5px;
`;

export const FormRowName = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${colors.shades.dark2};
`;

export const FormRowActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const ListActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
`;
